import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { CssBaseline, ThemeProvider, createTheme } from '@mui/material';
import './App.css';
import AgentForm from './pages/AgentForm';
import ScanForm from './pages/ScanForm';
import AdminList from './pages/AdminList';

const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Routes>
          <Route path="/agent" element={<AgentForm />} />
          <Route path="/scan" element={<ScanForm />} />
          <Route path="/" element={<AgentForm />} />
                    <Route path="/admin" element={<AdminList />} />

        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
